import React from 'react';
import { Box } from "@mui/system";
import {CustomStyleColorPickerPreview} from './Styles';

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * ColorPickerPreview renders a small square preview of a color,
 * showing both fill and stroke colors. This is useful for color picker UIs
 * where a visual representation of the selected colors is needed.
 *
 * @component
 *
 * @param {Object} props - Component props
 * @param {string} props.fillColor - The fill color to display in the preview square.
 * @param {string} props.strokeColor - The stroke/border color to display in the preview square.
 * @param {string} [props.pickerClasses=""] - Optional additional CSS classes for the inner preview square.
 *
 * @returns {JSX.Element} A styled color preview box.
 *
 * @example
 * <ColorPickerPreview fillColor="#FF0000" strokeColor="#000000" pickerClasses="custom-class" />
 *
*/
const ColorPickerPreview = ({ fillColor, strokeColor, pickerClasses="" }) => {
    const styles = CustomStyleColorPickerPreview({fillColor, strokeColor});
    return (
        <Box className={" p-1px border-radius-4px"} sx={styles.container}>
            <Box className={`h-20px w-20px border-radius-4px ${pickerClasses}`} sx={styles.body} />
        </Box>
    );
};

export default ColorPickerPreview;
